@use 'ui/styles/core-tokens' as core;

.formSkeleton {
  &Content {
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.buttonSkeleton {
  margin-right: 20px;
}
